export default __webpack_public_path__ + "images/GR.09f526a.png";